// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___cQzjZ";
var _2 = "styles-module__image___VPMyA";
var _3 = "styles-module__imageContainer___T1uS7";
var _4 = "styles-module__price___ZVoYR";
var _5 = "styles-module__title___qxTP6";
export { _1 as "container", _2 as "image", _3 as "imageContainer", _4 as "price", _5 as "title" }
